import './App.css';
import NewRecipe from './newRecipe.js'

function App() {
  return (
    <div className="App">
      <NewRecipe/>
    </div>
  );
}

export default App;
